import React, { Component } from "react";
import axios from "axios";
import FilterCourse from "./filter_bar_course";
import Empty from "../image/empty.svg"
import { Link } from "react-router-dom";
import { MdOutlineDeleteOutline } from "react-icons/md";


class TutorSearchContent extends Component {
    state = {
        courses: [],
        filter_type_name: "Type",
        filter_level_name: "Level",
        filter_status_name: "Status",
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.fetchCourses(this.props.search);
    }
    componentDidUpdate(prevProps) { // Add componentDidUpdate
        if (prevProps.search !== this.props.search) { // Check if the search prop has changed
            this.fetchCourses(this.props.search); // Fetch courses with the new search term
        }
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");
        const search = this.props.search; // Assuming this contains the search term

        try {
            const params = new URLSearchParams(); // Use URLSearchParams to build query string
            if (search) {  // Only add the search param if it's not empty
                params.append('search', search);
            }

            const url = `https://api.geoinfoacademy.com/api/tutor/courses/?${params.toString()}`;

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            this.setState({ courses: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle errors as needed
        }
    };


    handleRefresh = () => {
        this.setState({
            filter_type_name: "Type",
            selectedItem: "",
            filter_level_name: "Level",
            selectedItems: "",
            filter_status_name: "Status",
            selectedIteme: ""
        }, () => {
            // Important: Call the reset on the child!
            this.filterRef.handleReset(); // Assuming you add a ref to the FilterCourse component
        })
    }

    initialfilterbytype = () => {
        const courses = this.state.courses;
        if (this.state.filter_type_name === "Type" || this.state.filter_type_name === "All") {
            return courses
        } else {
            return courses.filter((item) => item.labels === this.state.filter_type_name);
    
        }
    };
    
    initialfilterbylevel = () => {
        const courses = this.initialfilterbytype();
        
        if (this.state.filter_level_name === "Level" || this.state.filter_level_name === "All") {
            return courses
        }else if (this.state.filter_level_name === "Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Advance" ||
                    item.tags === "Professional"
            );
        }else if (this.state.filter_level_name === "Beginner to Advance/Professional") {
            return courses.filter(
                (item) =>
                    item.tags === "Beginner to Advance" ||
                    item.tags === "Beginner to Professional"
            );
        } 
        
         else {
            return courses.filter((item) => item.tags === this.state.filter_level_name);
    
        }
    };
    initialfilterbystatus = () => {
        const courses = this.initialfilterbylevel();
        if (this.state.filter_status_name === "Status" || this.state.filter_status_name === "All") {
            return courses
        } else if (this.state.filter_status_name === "Online") {
            return courses.filter(
                (item) =>
                    item.training_type === "Online Prerecorded" ||
                    item.training_type === "Online Live with Facilitator"
            );
        } 
        // If "Physical" is selected, filter for "general physical class" and "private physical class"
        else if (this.state.filter_status_name === "Physical") {
            return courses.filter(
                (item) =>
                    item.training_type === "General Physical Class" ||
                    item.training_type === "Physical Private Class"
            );
        } 
        // Default case: If filter_level_name matches a specific training_type directly
        else {
            return courses.filter(
                (item) => item.training_type === this.state.filter_status_name
            );
        }
    };
    handleFilterChange = (filterType, filterLevel,filterStatus) => {
        this.setState({
            filter_type_name: filterType,
            filter_level_name: filterLevel,
            filter_status_name: filterStatus,
        })
    };



    handleDelete = async (course) => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.delete(`https://geoacademy.pythonanywhere.com/api/tutor/courses/${course.id}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
      
            if (response.status === 204 || response.status === 200) { // Check for successful delete status codes (204 No Content is common)
                console.log("Document deleted successfully:", course.id);
                this.fetchCourses(this.props.search);
            } else {
                console.error("Error deleting document:", response.status, response.data);
                alert("Error deleting document")
      
            }
        } catch (error) {
            console.error("Error deleting document:", error);
            alert("Error deleting document")
        }
      };
      
      
      

    render() {
        const searchdata = this.initialfilterbystatus()
        // console.log("search course", this.initialfilterbylevel())

        const SearchCourses = searchdata.length > 0 ? searchdata.map((course) => {
            return (

                <section className="course_library" key={course.id}>
                    <button className="edit" onClick={() => this.handleDelete(course)}><MdOutlineDeleteOutline /></button>
                    <Link to={"/description/" + course.id} >
                        <section className="image"><img src={course.thumbnail} alt="course_thumbnail" /></section>
                        <section className="content">
                            <h3>
                                <span> {course.labels} : {course.tags}</span><br />
                                {course.title}
                            </h3>
                            <p>{course.training_type} at #{course.price}</p>
                        </section>
                    </Link>
                </section>

            )
        }) : (
            <div className="course_list_empty">
                <img src={Empty} alt="not avaialable" /><br />
                <h5>No Available Course <br />with that specification.</h5>
                <button onClick={this.handleRefresh}>Reset Filter</button>
            </div>
        )

        return (
            <div >
                <div className="course_head">
                    <h2> Search </h2>
                    <FilterCourse
                        filterType={this.state.filter_type_name} // Pass current values as props
                        filterLevel={this.state.filter_level_name}
                        onFilterChange={this.handleFilterChange}
                        ref={(el) => this.filterRef = el}
                    />
                </div>
                <div className="search_content">
                    {SearchCourses}
                </div>
            </div>
        )
    }
}


export default TutorSearchContent